var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4205 10.1065L14.1471 11.3465C13.6738 13.4799 12.0005 14.9999 9.58715 14.9999H6.41381C4.00048 14.9999 2.32715 13.4799 1.85381 11.3465L1.58048 10.1065C1.44714 9.49988 1.80714 8.81321 2.38714 8.57987L3.33381 8.19987L7.00715 6.72654C7.32715 6.59988 7.66715 6.5332 8.00048 6.5332C8.33381 6.5332 8.67381 6.59988 8.99381 6.72654L12.6671 8.19987L13.6138 8.57987C14.1938 8.81321 14.5538 9.49988 14.4205 10.1065Z",
    fill: "#1D2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.6673 5.66602V8.19934L8.99398 6.72601C8.35398 6.47268 7.64732 6.47268 7.00732 6.72601L3.33398 8.19934V5.66602C3.33398 4.56602 4.23398 3.66602 5.33398 3.66602H10.6673C11.7673 3.66602 12.6673 4.56602 12.6673 5.66602Z",
    fill: "#1D2939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 3.66602H6.33398V2.33268C6.33398 1.96602 6.63398 1.66602 7.00065 1.66602H9.00065C9.36732 1.66602 9.66732 1.96602 9.66732 2.33268V3.66602Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIcon);
export default __webpack_public_path__ + "static/media/shipIcon.56bff8813eed9723cb34c26b71ab3198.svg";
export { ForwardRef as ReactComponent };